import Image from "./../image";

interface SettingItemProps {
  text: string;
  icon: string;
  onClick?: () => void;
  selected?: boolean;
}

const SettingItem: React.FC<SettingItemProps> = ({
  text,
  icon,
  onClick,
  selected = false,
}) => {
  return (
    <div
      className={`flex items-center w-full px-[32px] py-[8px] cursor-pointer hover:bg-white/5 ${
        selected ? "setting-item " : ""
      }`}
      onClick={onClick}
    >
      <div className="">
        <Image aria-hidden src={icon} alt="icon" width={20} height={20} />
      </div>
      <div className="text-400 p-[12px] primary-text-color">{text}</div>
      {selected ? (
        <div className="ml-auto">
          <Image
            aria-hidden
            src="/assets/icon_check.png"
            alt="icon"
            width={20}
            height={20}
          />
        </div>
      ) : null}
    </div>
  );
};

export default SettingItem;
